import React from "react";
import PropTypes from "prop-types";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import styles from "./AllocToPdqGraph.module.css";

const CustomTooltip = ({ active, payload, label, selectedLossType }) => {
  if (active && payload?.length) {
    return (
      <div className={styles.tooltipBox}>
        <div className={styles.tooltipDate}>{label}</div>

        <div className={styles.blue}>
          {selectedLossType} : {payload?.[0]?.value?.toLocaleString?.() ?? 0} %
        </div>
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  payload: PropTypes.array,
  selectedLossType: PropTypes.string,
};

CustomTooltip.defaultProps = {
  active: false,
  label: "",
  payload: [],
  selectedLossType: "Master Loss",
};

const formatDate = (date) => {
  const d = new Date(date);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  return `${d.getDate()} ${months[d.getMonth()]}`;
};

const AllocToPdqGraph = ({ data, loading, selectedLossType }) => {
  if (loading) {
    return (
      <div className={styles.shimmerWrapper}>
        <div className={styles.shimmerChart}></div>
      </div>
    );
  }

  if (!data?.length) {
    return <div className={styles.centerState}>No Data</div>;
  }

  const chartWidth = data.length > 10 ? `${data.length * 60}px` : "100%";

  return (
    <div className={styles.graphContainer}>
      <div className={styles.horizontalScroll}>
        <div className={styles.chartWrapper} style={{ width: chartWidth }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{
                top: 10,
                right: 20,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                horizontal={false}
                vertical
              />

              <XAxis
                dataKey="IngestedDate"
                tick={{ fontSize: 12 }}
                tickFormatter={formatDate}
                interval={0}
              />

              <YAxis tick={{ fontSize: 12 }} />

              <Tooltip
                content={<CustomTooltip selectedLossType={selectedLossType} />}
              />

              {/* <Line
                type="linear"
                dataKey="loss percent"
                stroke="#1f77b4"
                strokeWidth={2}
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
                name={selectedLossType}
              /> */}
              <Line
                type="monotone"
                dataKey="loss percent"
                stroke="#e75fc5"
                strokeWidth={2}
                dot={{
                  r: 3,
                  fill: "#e75fc5",
                  stroke: "#e75fc5",
                }}
                activeDot={{
                  r: 5,
                  fill: "#ef3dc3",
                  stroke: "#ef3dc3",
                }}
                name={selectedLossType}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

AllocToPdqGraph.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  selectedLossType: PropTypes.string,
};

AllocToPdqGraph.defaultProps = {
  data: [],
  loading: false,
  selectedLossType: "Master Loss",
};

export default AllocToPdqGraph;
